import tocbot from 'tocbot';

export function indexMake() {
  // 見出しにid自動付与
  const articleHeadingLv2Trigger = document.querySelectorAll('.js-articleHeadingLv2');
  const articleHeadingLv2TriggerList = Array.prototype.slice.call(articleHeadingLv2Trigger, 0);
  const articleHeadingLv3Trigger = document.querySelectorAll('.js-articleHeadingLv3');
  const articleHeadingLv3TriggerList = Array.prototype.slice.call(articleHeadingLv3Trigger, 0);

  for (let i = 0; i < articleHeadingLv2TriggerList.length; i++) {
    let idCraft = 'lv2-' + (i + 1);
    console.log(idCraft);
    articleHeadingLv2TriggerList[i].setAttribute('id', idCraft);
  }

  for (let i = 0; i < articleHeadingLv3TriggerList.length; i++) {
    let idCraft = 'lv3-' + (i + 1);
    console.log(idCraft);
    articleHeadingLv3TriggerList[i].setAttribute('id', idCraft);
  }

  // 目次生成
  tocbot.init({
    // Where to render the table of contents.
    tocSelector: '.js-toc',
    // Where to grab the headings to build the table of contents.
    contentSelector: '.js-toc-content',
    // Which headings to grab inside of the contentSelector element.
    headingSelector: 'h2,h3',
    // For headings inside relative or absolute positioned containers within content.
    hasInnerContainers: true,
    collapseDepth: 4,
    scrollSmooth: false,
  });
}
